export default __webpack_public_path__ + "static/media/pfoten-mockup-mobile.c29387de.png";